module.exports = "td{\r\n    border: 1px solid #ddd;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/approved-drawing/approved-drawing-grid/approved-drawing-grid.component.css
// module id = ./src/app/planning/approved-drawing/approved-drawing-grid/approved-drawing-grid.component.css
// module chunks = main